import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './style.css';

import { api } from 'services';

const RegisterPassword = ({
  authenticate,
  location,
  registerpassword,
  //error,
  match: {
    params: { id, token },
  },
}) => {
  //const [password, setPassword] = useState('');
  //const [passwordconfirm, setPasswordConfirm] = useState('');
  const [status, setStatus] = useState('error');
  const { from } = location.state || { from: { pathname: '/login' } };
  const [reports, setReports] = useState({ data: [] });
  const { t } = useTranslation();

  var erro_password = { status: false, message: '' };
  var password = '';
  var passwordconfirm = '';

  useEffect(() => {
    document.addEventListener('mousemove',(e)=>{
      let posX = (e.screenX * 10)/window.innerWidth - 5;
      let posY = (e.screenY * 10)/window.innerHeight - 5;
      let img = document.getElementById('background-img');
      if(img){
        img.style.marginLeft = `calc(-5px + ${(posX * -1).toFixed(2)}px)`;
        img.style.marginTop = `calc(-5px + ${(posY * -1).toFixed(2)}px)`;
      }
    });
  },[])

  function teste() {
    api
      .post('register-password/verify-token', { token: token, id: id })
      .then(({ data }) => {
        setStatus(data.status);
      });
  }
  teste();
  function submit_password(password) {
    if (!erro_password.status) {
      api
        .post('register-password', { token: token, id: id, password: password })
        .then(({ data }) => {
          window.location.href = location;
        });
    }
  }
  function error(status, message, id) {
    erro_password.status = status;
    erro_password.message = message;
    var erro = document.getElementById(id);
    if (erro != null) {
      erro.style.display = status ? '' : 'none';
      erro.innerText = erro_password.message;
    }
  }

  if (authenticate) return <Redirect to={from.pathname} location={location} />;
  if (status == 'not found') {
    return <Redirect to={from.pathname} location={location} />;
  }

  function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }
  function hasWhiteSpace(s) {
    return s.indexOf(' ') >= 0;
  }

  return (
    <div className="login" id="registerpassword">
      <Row className="h-100 p-0 m-0">
        <Col md="5" className="h-100 p-3 m-0 areaForm">
        <div className="login-form">
          <span>
            <img src="/logo-light.png" alt="SCANSOURCE" className="scan-logo" />
          </span>
          <Form
            onSubmit={(e) => {
            e.preventDefault();
            submit_password(password);
            }}
          >
            <Form.Group>
              <Form.Label>{t('label:password')}</Form.Label>
              <Form.Control
                id="password"
                type="password"
                placeholder="Digite uma senha"
                onChange={(e) => {
                  if (isEmptyOrSpaces(e.target.value))
                    error(true, 'Digite uma senha correta', 'passwordHelp1');
                  else if (hasWhiteSpace(e.target.value))
                    error(true, 'Senha não pode ter espaço', 'passwordHelp1');
                  else if (
                    document.getElementById('password2').value != e.target.value
                  )
                    error(true, 'As senhas estão diferentes', 'passwordHelp2');
                  else error(false, '', 'passwordHelp1');
                  password = e.target.value;
                }}
                required
              />
              <Form.Text style={{ height: '10px' }}>
                <span
                  id="passwordHelp1"
                  className="text-danger"
                  style={{ display: 'none' }}
                >
                  Must be 8-20 characters long.
                </span>
              </Form.Text>
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirmar senha</Form.Label>
              <Form.Control
                type="password"
                id="password2"
                placeholder="Confirme sua senha"
                onChange={(e) => {
                  if (isEmptyOrSpaces(e.target.value))
                    error(true, 'Digite uma senha correta', 'passwordHelp2');
                  else if (hasWhiteSpace(e.target.value))
                    error(true, 'Senha não pode ter espaço', 'passwordHelp2');
                  else if (
                    document.getElementById('password').value != e.target.value
                  )
                    error(true, 'As senhas estão diferentes', 'passwordHelp2');
                  else error(false, '', 'passwordHelp2');
                  passwordconfirm = e.target.value;
                }}
                required
              />
              <Form.Text style={{ height: '10px' }}>
                <span
                id="passwordHelp2"
                className="text-danger"
                style={{ display: 'none' }}
                >
                  Must be 8-20 characters long.
                </span>
              </Form.Text>
            </Form.Group>
            <Button block type="submit" variant="primary-login" className="forgot-btn" style={{backgroundColor:'#d71925'}} id="forgot-btn">
              Cadastrar senha
            </Button>
          </Form>
        </div>
        </Col>
        <Col md="7" className="h-100 p-0 m-0 mobileHidden left-area">
          <div id="background-img"></div>
          <img src="/logo-branco-scan.png" alt="SIM" className="logo-trend"/>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(RegisterPassword);
